export const QA_CONFIGS = {
  RELEASE: '1.0',
  BASE_URL: 'https://qa.sandbox.instarem.com/api/',
  TIMEOUT: 100000,
  VISION_CHECK_COUNT_LIMIT: 2,
  SME_URL: 'https://sme-ui.qa.instarem.com',
  GTM_ID: 'GTM-KLZ7JW',
  FLAGSMITH_URL: 'https://retail-flagsmith.qa.instarem.com/api/v1/flags'
};

export const PREPROD_CONFIGS = {
  RELEASE: '1.0',
  BASE_URL: 'https://ui.sandbox.instarem.com/api/',
  TIMEOUT: 100000,
  VISION_CHECK_COUNT_LIMIT: 2,
  SME_URL: 'https://sme-ui.preprod.instarem.com',
  GTM_ID: 'GTM-KLZ7JW',
  FLAGSMITH_URL: 'https://retail-flagsmith.preprod.instarem.com/api/v1/flags'
};

export const PROD_CONFIGS = {
  RELEASE: '1.0',
  BASE_URL: 'https://www.instarem.com/api/',
  TIMEOUT: 100000,
  VISION_CHECK_COUNT_LIMIT: 1,
  SME_URL: 'https://biz.instarem.com',
  GTM_ID: 'GTM-M6RPP9W',
  FLAGSMITH_URL: 'https://flagsmith.nium.com/api/v1/flags'
};
